export const codeBlockTheme = {
  backgroundColor: "var(--tertiary50)",
  textColor: "var(--text)",
  codeColor: "var(--text)"
};